import { faTrashAlt } from '@fortawesome/pro-light-svg-icons';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { ChangeEvent, useContext } from 'react';
import * as ConsoleStore from '../../store/Console';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { ApplicationState } from '../../store';
import { push } from 'connected-react-router';
import { Container } from 'reactstrap';
import { AutoComplete, AutoCompleteChangeEvent, DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { addUserDashboards, createDashboard, deleteDashboard, deleteUserDashboard, getDashboards, getInternalIdps, searchUserList, updateDashboard } from '../../ApiUtils/ApiUtils';
import './Dashboards.css'
import { UserProfileContext } from '../Console/ConsoleLayout';
import SupportTeam from '../Console/Dashboard/SupportTeam';
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { faEye, faEyeSlash } from '@fortawesome/pro-solid-svg-icons';

const defaultGuid = '00000000-0000-0000-0000-000000000000';

const defaultQuickSightDashboardEntity: DashboardEntity = {
    description: '',
    id: 0,
    key: defaultGuid,
    name: '',
    setting: {
        accessKey: '',
        authorizedResourceArns: [],
        awsAccountId: '',
        dashboardRefId: 0,
        id: 0,
        initialDashboardId: '',
        namespace: 'default',
        region: 'us-east-1',
        secretAccessKey: ''
    },
    type: 1,
    userDashboards: []
}

const defaultPowerBIDashboardEntity: DashboardEntity = {
    description: '',
    id: 0,
    key: defaultGuid,
    name: '',
    setting: {
        dashboardRefId: 0,
        id: 0,
        initialDashboardId: '',
        authenticationMode: "ServicePrincipal",
        tenantId: '',
        clientId: '',
        clientSecret: '',
        scopeBase: "https://analysis.windows.net/powerbi/api/.default",
        authorityUrl: "https://login.microsoftonline.com/organizations",
        powerBiApiUrl: 'https://api.powerbi.com/',
        powerBiUser: '',
        powerBiPass: ''
    },
    type: 2,
    userDashboards: []
}
const defaultApplicationsDashboardEntity: DashboardEntity = {
    description: '',
    id: 0,
    key: defaultGuid,
    name: '',
    type: 0,
    userDashboards: [],
    setting: {
        id: 0,
        createdAt: undefined,
        dashboard: undefined,
        dashboardRefId: 0,
        updatedAt: undefined
    }
}

interface ApplicationSetting {
    $id?: number;
    createdAt: Date;
    dashboard: {
        $id: number;
    };
    dashboardRefId: number;
    id: number;
    updatedAt: Date;
}

interface QuickSightSetting {
    $id?: number;
    accessKey: string;
    authorizedResourceArns: AuthorizedResourceArn[];
    awsAccountId: string;
    createdAt?: Date;
    dashboard?: {
        $id: number;
    };
    dashboardRefId: number;
    id: number;
    initialDashboardId: string;
    namespace: string;
    region: string;
    secretAccessKey: string;
    updatedAt?: Date;
}

interface PowerBISetting {
    $id?: number;
    createdAt?: Date;
    dashboard?: {
        $id: number;
    };
    dashboardRefId: number;
    id: number;
    updatedAt?: Date;
    authenticationMode?: string;
    workspaceId?: string;
    reportId?: string;
    tenantId?: string;
    clientId?: string;
    clientSecret?: string;
    scopeBase?: string;
    authorityUrl?: string;
    powerBiApiUrl?: string;
    powerBiUser?: string;
    powerBiPass?: string;
}


interface AuthorizedResourceArn {
    $id?: number;
    arn: string;
    createdAt?: Date;
    id: number;
    setting?: {
        $id?: number;
    };
    settingId: number;
    updatedAt?: Date;
}

function isQuickSightSetting(setting: ApplicationSetting | QuickSightSetting | PowerBISetting): setting is QuickSightSetting {
    return (setting != null && (setting as QuickSightSetting).accessKey !== undefined);
}

function isPowerBISetting(setting: ApplicationSetting | QuickSightSetting | PowerBISetting): setting is PowerBISetting {
    return (setting != null && (setting as PowerBISetting).powerBiApiUrl !== undefined);
}

interface DashboardEntity {
    $id?: number;
    createdAt?: Date;
    description: string;
    id: number;
    key: string;
    name: string;
    setting: ApplicationSetting | QuickSightSetting | PowerBISetting;
    type: number;
    updatedAt?: Date;
    userDashboards: UserDashboard[];
}

interface UserEntity {
    $id?: number;
    email: string;
    userName: string;
}

interface UserDashboard {
    $id?: number;
    dashboard: {
        $id?: number;
    };
    id: number;
    userId: number;
    user: UserEntity;
}

interface DashboardFormState {
    companies: any[];
    currentCompany?: any;
    dashboard: DashboardEntity;
    isSaving: boolean;
    showSaveConfirm: boolean; 
    showPassword: boolean;
}

interface DashboardFormProps {
    dashboard?: DashboardEntity;
    onCancel?: () => void;
    onSaved?: () => void;
    company?: object
}

class DashboardForm extends React.Component<DashboardFormProps, DashboardFormState> {
    constructor(props: DashboardFormProps) {
        super(props);
        let dashboard;
        if (props.dashboard) {
            dashboard = {
                ...props.dashboard
            };
        }
        else {
            dashboard = {
                ...defaultQuickSightDashboardEntity
            };
        }
        this.state = {
            companies: [],
            dashboard: dashboard,
            isSaving: false,
            currentCompany: props.company,
            showSaveConfirm: false,
            showPassword: false
        }
    }

    private handleCancel = () => {
        this.props.onCancel && this.props.onCancel();
    };

    private handleDashboardTypeChange = (event: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        var newDashboard: DashboardEntity = defaultQuickSightDashboardEntity;
        if (event.target.value == "2") {
            newDashboard = defaultPowerBIDashboardEntity;
        }
        if (event.target.value == "0") {
            newDashboard = defaultApplicationsDashboardEntity;
        }
        this.setState({
            dashboard: newDashboard
        });
    }
    private handleDashboardChange = (event: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        this.setState({
            dashboard: {
                ...this.state.dashboard,
                [event.target.name]: event.target.value
            }
        });
    }

    private handleQuickSightSettingChange = (event: ChangeEvent<HTMLInputElement>) => {
        this.setState({
            dashboard: {
                ...this.state.dashboard,
                setting: {
                    ...this.state.dashboard.setting,
                    [event.target.name]: event.target.value
                }
            }
        });
    }

    private handlePowerBISettingChange = (event: ChangeEvent<HTMLInputElement>) => {
        this.setState({
            dashboard: {
                ...this.state.dashboard,
                setting: {
                    ...this.state.dashboard.setting,
                    [event.target.name]: event.target.value
                }
            }
        });
    }

    private handleQuickSightArnChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        var arns = event.target.value.split("\n");
        this.setState({
            dashboard: {
                ...this.state.dashboard,
                setting: {
                    ...this.state.dashboard.setting,
                    authorizedResourceArns: arns.map(value => ({
                        arn: value,
                        id: 0,
                        settingId: this.state.dashboard.setting.id
                    } as AuthorizedResourceArn))
                }
            }
        });
    }

    private handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        this.setState({ showSaveConfirm: true });
    };

    private handleConfirmSave = () => {
        this.setState({ isSaving: true, showSaveConfirm: false }, () => {
            if (this.state.dashboard.id === 0) {
                createDashboard(this.state.dashboard, this.state.currentCompany.name)
                    .then(result => {
                        this.props.onSaved && this.props.onSaved();
                    })
                    .catch(reason => {
                        console.log(reason);
                    }).finally(() => {
                        this.setState({ isSaving: false });
                    });
            } else {
                updateDashboard(this.state.dashboard)
                    .then(result => {
                        this.props.onSaved && this.props.onSaved();
                    })
                    .catch(reason => {
                        console.log(reason);
                    }).finally(() => {
                        this.setState({ isSaving: false });
                    });
            }
        });
    };

    private handleCancelSave = () => {
        this.setState({ showSaveConfirm: false });
    };

    private toggleShowPassword = () => {
        this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
    };

    public render() {
        return (
            <div className="container-fluid">
                <form onSubmit={this.handleSubmit}>
                    <div className="mt-1">{this.props.dashboard ? "Edit Dashboard" : "Create Dashboard"}</div>

                    <div className="mb-1">
                        <label className="form-label">Type</label>
                        <select className="form-select" value={this.state.dashboard?.type} name="type" onChange={this.handleDashboardTypeChange}>
                            <option value={2}>Power BI</option>
                        </select>
                    </div>
                    <div className="mb-1">
                        <label className="form-label">Name</label>
                        <input type="text" className="form-control" value={this.state.dashboard?.name} name="name" onChange={this.handleDashboardChange}></input>
                    </div>
                    <div className="mb-1">
                        <label className="form-label">Description</label>
                        <textarea className="form-control" value={this.state.dashboard?.description} name="description" onChange={this.handleDashboardChange}></textarea>
                    </div>
                    <div><b>Settings</b></div>
                    {this.state.dashboard && isQuickSightSetting(this.state.dashboard.setting) && (
                        <>
                            <div className="mb-1">
                                <label className="form-label">AWS Account ID</label>
                                <input type="text" className="form-control" value={this.state.dashboard.setting.awsAccountId} name="awsAccountId" onChange={this.handleQuickSightSettingChange}></input>
                            </div>
                            <div className="mb-1">
                                <label className="form-label">Access Key</label>
                                <input type="text" className="form-control" value={this.state.dashboard.setting.accessKey} name="accessKey" onChange={this.handleQuickSightSettingChange}></input>
                            </div>
                            <div className="mb-1">
                                <label className="form-label">Secret Access Key</label>
                                <input type="password" className="form-control" value={this.state.dashboard.setting.secretAccessKey} name="secretAccessKey" onChange={this.handleQuickSightSettingChange}></input>
                            </div>
                            <div className="mb-1">
                                <label className="form-label">Region</label>
                                <input type="text" className="form-control" value={this.state.dashboard.setting.region} name="region" onChange={this.handleQuickSightSettingChange}></input>
                            </div>
                            <div className="mb-1">
                                <label className="form-label">Initial Dashboard ID</label>
                                <input type="text" className="form-control" value={this.state.dashboard.setting.initialDashboardId} name="initialDashboardId" onChange={this.handleQuickSightSettingChange}></input>
                            </div>
                            <div className="mb-1">
                                <label className="form-label">Namespace</label>
                                <input type="text" className="form-control" value={this.state.dashboard.setting.namespace} name="namespace" onChange={this.handleQuickSightSettingChange}></input>
                            </div>
                            <div className="mb-1">
                                <label className="form-label">Authorized Resource Arns (1 arn per row)</label>
                                <textarea className="form-control" placeholder="1 arn per row" value={this.state.dashboard.setting.authorizedResourceArns.map(value => value.arn).join("\n")} onChange={this.handleQuickSightArnChange}></textarea>
                            </div>
                        </>)}
                    {this.state.dashboard && isPowerBISetting(this.state.dashboard.setting) && (
                        <>
                            <div className="mb-1">
                                <label className="form-label">Authentication Mode</label>
                                <input type="text" className="form-control" value={this.state.dashboard.setting.authenticationMode} name="authenticationMode" onChange={this.handlePowerBISettingChange}></input>
                            </div>
                            <div className="mb-1">
                                <label className="form-label">Workspace ID</label>
                                <input type="text" className="form-control" value={this.state.dashboard.setting.workspaceId} name="workspaceId" onChange={this.handlePowerBISettingChange}></input>
                            </div>
                            <div className="mb-1">
                                <label className="form-label">Report ID</label>
                                <input type="text" className="form-control" value={this.state.dashboard.setting.reportId} name="reportId" onChange={this.handlePowerBISettingChange}></input>
                            </div>
                            <div className="mb-1">
                                <label className="form-label">Tenant ID</label>
                                <input type="text" className="form-control" value={this.state.dashboard.setting.tenantId} name="tenantId" onChange={this.handlePowerBISettingChange}></input>
                            </div>
                            <div className="mb-1">
                                <label className="form-label">Client ID</label>
                                <input type="text" className="form-control" value={this.state.dashboard.setting.clientId} name="clientId" onChange={this.handlePowerBISettingChange}></input>
                            </div>
                            <div className="mb-1">
                                <label className="form-label">Client Secret</label>
                                <div style={{ position: 'relative' }}>
                                    <input type={this.state.showPassword ? "text" : "password"} className="form-control" value={this.state.dashboard.setting.clientSecret} name="clientSecret" onChange={this.handlePowerBISettingChange}></input>
                                    <span onClick={this.toggleShowPassword} className="password-eye-dashboard">
                                        <FontAwesomeIcon icon={this.state.showPassword ? faEyeSlash : faEye} />
                                    </span>
                                </div>
                            </div>
                            <div className="mb-1">
                                <label className="form-label" style={{ userSelect: 'none' }}>Scope Base <span style={{ fontSize: "0.7rem" }}>( Comma-separated URLs )</span></label>
                                <input type="text" className="form-control" value={this.state.dashboard.setting.scopeBase} name="scopeBase" onChange={this.handlePowerBISettingChange}></input>
                            </div>
                            <div className="mb-1">
                                <label className="form-label">Authority URL</label>
                                <input type="text" className="form-control" value={this.state.dashboard.setting.authorityUrl} name="authorityUrl" onChange={this.handlePowerBISettingChange}></input>
                            </div>
                            <div className="mb-1">
                                <label className="form-label">Power BI API URL</label>
                                <input type="text" className="form-control" value={this.state.dashboard.setting.powerBiApiUrl} name="powerBiApiUrl" onChange={this.handlePowerBISettingChange}></input>
                            </div>
                            <div className="mb-1">
                                <label className="form-label">Power BI user</label>
                                <input type="text" className="form-control" value={this.state.dashboard.setting.powerBiUser} name="powerBiUser" onChange={this.handlePowerBISettingChange}></input>
                            </div>
                            <div className="mb-1">
                                <label className="form-label">Power BI pass</label>
                                <input type="password" className="form-control" value={this.state.dashboard.setting.powerBiPass} name="powerBiPass" onChange={this.handlePowerBISettingChange}></input>
                            </div>
                        </>)}
                    <div className="my-2">
                        <button className="btn btn-primary" type="submit" disabled={this.state.isSaving}>Save</button>
                        <button className="btn btn-secondary ms-1" onClick={this.handleCancel}>Cancel</button>
                    </div>
                </form>

                {this.state.showSaveConfirm && (
                    <Dialog title="Apply Dashboard changes?" onClose={this.handleCancelSave}>
                        <p style={{ margin: '25px', textAlign: 'center' }}>
                            This action will update your dashboard permanently. Changes cannot be undone.
                        </p>
                        <DialogActionsBar>
                            <button
                                className="modal-button cancel-button"
                                onClick={this.handleCancelSave}
                            >
                                No
                            </button>
                            <button
                                className="modal-button confirm-button"
                                onClick={this.handleConfirmSave}
                            >
                                Yes
                            </button>
                        </DialogActionsBar>
                    </Dialog>
                )}
            </div>
        );
    }
}

interface LinkedUsersManagementState {
    email: string;
    userDashboards: UserDashboard[];
    hasError: boolean;
    errorMessage: string;
    currentCompany: any,
    showTooltip: boolean;
    showDeleteUserConfirm: boolean;
    userDashboardToDelete?: UserDashboard;
    suggestions: string[];
    loadingSuggestions: boolean;
}

interface LinkedUsersManagementProps {
    currentCompany: object
    dashboard: DashboardEntity;
    onLinkUser: () => void;
}

class LinkedUsersManagement extends React.Component<LinkedUsersManagementProps, LinkedUsersManagementState> {
    private searchTimer: ReturnType<typeof setTimeout> | undefined;
    private searchSeq = 0;
    private mounted = true;

    constructor(props: LinkedUsersManagementProps) {
        super(props);
        this.state = {
            email: '',
            userDashboards: this.sortUserDashboards(this.props.dashboard.userDashboards),
            hasError: false,
            errorMessage: '',
            currentCompany: props.currentCompany,
            showTooltip: false,
            showDeleteUserConfirm: false,
            userDashboardToDelete: undefined,
            suggestions: [],
            loadingSuggestions: false
        };
    }

    componentWillUnmount() {
        this.mounted = false;
        if (this.searchTimer) {
            clearTimeout(this.searchTimer);
        }
    }

    private sortUserDashboards = (source: UserDashboard[]): UserDashboard[] => {
        return source.sort((a, b) => a.user.email > b.user.email ? 1 : (a.user.email === b.user.email ? 0 : -1))
    }

    private handleAutocompleteEmailChange = (event: AutoCompleteChangeEvent) => {
        const value = event.target.value;
        this.setState({ email: value });

        if (this.searchTimer) {
            clearTimeout(this.searchTimer);
        }

        if (!value) {
            this.searchSeq++;
            this.setState({ suggestions: [], loadingSuggestions: false });
            return;
        }

        this.setState({ loadingSuggestions: true });
        const seq = ++this.searchSeq;
        this.searchTimer = setTimeout(() => {
            searchUserList(this.state.currentCompany.name, value)
                .then((response: string) => {
                    if (!this.mounted || seq !== this.searchSeq) {
                        return;
                    }
                    const users = JSON.parse(response);
                    const emails = users.map((user: any) => user?.email).filter(Boolean);
                    this.setState({ suggestions: emails, loadingSuggestions: false });
                })
                .catch((error: any) => {
                    if (!this.mounted || seq !== this.searchSeq) {
                        return;
                    }
                    console.error('Failed to search user list:', error);
                    this.setState({ suggestions: [], loadingSuggestions: false });
                });
        }, 300);
    }

    private handleUnlinkUser = (_event: React.MouseEvent<HTMLButtonElement>, userDashboard: UserDashboard) => {
        this.setState({
            showDeleteUserConfirm: true,
            userDashboardToDelete: userDashboard
        });
    };

    private handleConfirmUnlinkUser = () => {
    const { userDashboardToDelete } = this.state;
    if (!userDashboardToDelete) return;

    deleteUserDashboard(this.props.dashboard.key, userDashboardToDelete.id)
        .then(() => {
            const updatedList = this.state.userDashboards.filter(ud => ud.id !== userDashboardToDelete.id);
            this.setState({
                userDashboards: this.sortUserDashboards(updatedList),
                showDeleteUserConfirm: false,
                userDashboardToDelete: undefined
            });
        })
        .catch(reason => {
            console.log(reason);
            this.setState({ showDeleteUserConfirm: false });
        });
        };

        private handleCancelUnlinkUser = () => {
            this.setState({
                showDeleteUserConfirm: false,
                userDashboardToDelete: undefined
            });
        };

    private handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        addUserDashboards(this.props.dashboard.key, [this.state.email])
            .then(result => {
                this.setState({
                    hasError: false,
                    errorMessage: '',
                    email: '',
                    userDashboards: this.sortUserDashboards([...this.state.userDashboards, ...(result.data.userDashboards as UserDashboard[])])
                });
                this.props.onLinkUser && this.props.onLinkUser();
            })
            .catch(reason => {
                console.log(reason);
                this.setState({
                    hasError: true,
                    errorMessage: 'This user has been linked to another dashboard'
                });
            })
            .finally(() => {
            });
    }

    public render() {
        return (
            <>
                <form onSubmit={this.handleSubmit}>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="input-group mb-1">
                                <AutoComplete
                                    style={{ width: '70%' }}
                                    data={this.state.suggestions}
                                    loading={this.state.loadingSuggestions}
                                    value={this.state.email}
                                    onChange={this.handleAutocompleteEmailChange}
                                    placeholder="Email address"
                                />
                                <button className="btn btn-sm btn-primary me-1" type="submit" disabled={!this.state.email}>Link User</button><br />
                            </div>
                           <div className="allowed-domain-container">
                            <div
                                className="info-icon-wrapper"
                                onMouseEnter={() => this.setState({ showTooltip: true })}
                                onMouseLeave={() => this.setState({ showTooltip: false })}
                            >
                                <FontAwesomeIcon icon={faInfoCircle} className="info-icon" />
                                {this.state.showTooltip && (
                                <div className="info-tooltip">
                                    <strong>TIP:</strong> You can link an email address if its domain matches the domain set up for the selected Company.
                                </div>
                                )}
                            </div>
                            <span>Allowed domain name(s): {this.state.currentCompany.domains}</span>
                            </div>

                        </div>
                    </div>
                    {this.state.hasError && (
                        <div className="row">
                            <div className="col-12">
                                <div className="alert alert-danger">{this.state.errorMessage}</div>
                            </div>
                        </div>)}
                </form>
                {this.state.userDashboards && this.state.userDashboards.length > 0 && (
                    <>
                        <div className="mb-1">
                            <span className="me-2">Linked Users</span>
                        </div>
                        {this.state.userDashboards.map(ud => (
                            <button key={ud.id} className="btn btn-sm btn-error me-2 link-del-btn-mb" onClick={(event) => this.handleUnlinkUser(event, ud)}>
                                <FontAwesomeIcon icon={faTrashAlt} className="me-1" />{ud.user?.email}
                            </button>))}
                    </>)}
                    {this.state.showDeleteUserConfirm && (
                    <Dialog title="Unlink User?" onClose={this.handleCancelUnlinkUser}>
                        <p style={{ margin: '25px', textAlign: 'center' }}>
                            Are you sure you want to unlink the user <strong>{this.state.userDashboardToDelete?.user?.email}</strong> from this dashboard?
                        </p>
                        <DialogActionsBar>
                        <button
                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base cancel-button"
                            onClick={this.handleCancelUnlinkUser}
                        >
                            No
                        </button>
                        <button
                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base confirm-button"
                            onClick={this.handleConfirmUnlinkUser}
                        >
                            Yes
                        </button>
                        </DialogActionsBar>
                    </Dialog>
                )}
            </>
        );
    }
}


interface DashboardManagementState {
    companies: any[];
    currentCompany?: any;
    dashboards: DashboardEntity[];
    displayDashboardForm: boolean;
    targetDashboard?: DashboardEntity;
    isLoading: boolean;
    showDeleteConfirm: boolean;
    dashboardToDelete?: DashboardEntity;
}

class DashboardManagement extends React.Component<any, DashboardManagementState> {
    static contextType = UserProfileContext;

    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: true,
            dashboards: [],
            companies: [],
            displayDashboardForm: false,
            showDeleteConfirm: false,
            dashboardToDelete: undefined

        };
    }

    componentDidMount() {
        this.initDashboards();
    }

    private initDashboards = () => {
        if (this.context && (this.context.permissions.root || this.context.permissions.admin)) {
            getInternalIdps().then((response: any) => {
                this.setState({ companies: response, currentCompany: this.props.console.applicationsState.currentCompany.name ? this.props.console.applicationsState.currentCompany : response.filter((i:any) => i.name === this.context.company)[0] || response[0] });
                this.getCompanyDashBoards(this.props.console.applicationsState.currentCompany?.name || this.context?.company || response[0].name);
            }).catch(() => {
                this.setState({ isLoading: false });
            });
        } else {
            // Not an admin/root user: nothing to load, so clear the loading state
            // instead of leaving the header spinner running forever.
            this.setState({ isLoading: false });
        }
    };

    private mapDashboardType = (type: number) => {
        if (type === 0) {
            return "Applications";
        }
        else if (type === 1) {
            return "QuickSight";
        } else if (type === 2) {
            return "Power BI";
        }
    }

    private handleAddDashboard = () => {
        this.setState({ displayDashboardForm: true, targetDashboard: defaultPowerBIDashboardEntity });
    }

    private handleDelete = (
        _event: React.MouseEvent<HTMLButtonElement>,
        dashboard: DashboardEntity
    ) => {
        this.setState({
            showDeleteConfirm: true,
            dashboardToDelete: dashboard
        });
    };

    private handleConfirmDelete = async () => {
        const { dashboardToDelete, currentCompany } = this.state;
        if (!dashboardToDelete) return;
        try {
            await deleteDashboard(dashboardToDelete.key);
            this.setState({ showDeleteConfirm: false, dashboardToDelete: undefined });
            this.getCompanyDashBoards(currentCompany.name);
        } catch (error) {
            console.error(error);
        }
    };

    private handleCancelDelete = () => {
        this.setState({ showDeleteConfirm: false, dashboardToDelete: undefined });
    };

    private handleEdit = (_event: React.MouseEvent<HTMLButtonElement>, dashboard: DashboardEntity) => {
        this.setState({
            displayDashboardForm: false
        }, () => {
            this.setState({
                displayDashboardForm: true,
                targetDashboard: dashboard
            });
        });
    }

    private handleCancel = () => {
        this.setState({
            displayDashboardForm: false,
            targetDashboard: undefined
        });
    }

    private handleSaved = () => {
        this.setState({ displayDashboardForm: false }, () => {
            this.getCompanyDashBoards(this.state.currentCompany.name);
        });
    }

    private handleLinkUser = () => {
        // refresh list
    }

    public handleCompanyChange = (event: DropDownListChangeEvent) => {
        if (event.target.value.domains == "" || event.target.value.domains.split(',').length == 0) {
            alert("No domain names configured for this company. Please configure domain names first");
            return;
        }
        this.setState({ currentCompany: event.target.value, });
        this.getCompanyDashBoards(event.target.value.name);
    }

    public getCompanyDashBoards = (pCompanyName: string) => {
        this.setState({ isLoading: true });
        getDashboards(pCompanyName).then(result => {
            this.setState({
                dashboards: result.data.dashboards,
                isLoading: false
            });
        }).catch(() => {
            this.setState({ isLoading: false });
        });
    }

    public render() {
        return (
            <Container fluid style={{ position: 'relative' }}>
                <br />
                <h3 style={{ display: "inline-block" }}>Dashboards</h3> <span> {this.state.isLoading && <FontAwesomeIcon icon={faSpinner} size="1x" spin={true} />} </span><br />

                <DropDownList
                    data={this.state.companies}
                    textField="name"
                    value={this.state.currentCompany}
                    onChange={this.handleCompanyChange}
                    style={{
                        width: '200px',
                        display: (this.state.companies.length > 1 && (this.context?.permissions.root || this.context?.permissions.admin)) ? 'block' : 'none'
                    }}
                />

                <button
                    onClick={this.handleAddDashboard}
                    className="btn btn-primary"
                    style={{
                        display: this.state.currentCompany ? 'block' : 'none',
                        width: '175px',
                        position: 'absolute',
                        top: '32px',
                        right: '40px'
                    }}
                >
                    New Dashboard
                </button>

                {this.state.displayDashboardForm && (
                    <DashboardForm
                        company={this.state.currentCompany}
                        dashboard={this.state.targetDashboard}
                        onSaved={this.handleSaved}
                        onCancel={this.handleCancel}
                    />
                )}

                <table className="table dashboards tbl-mb-5rem">
                    <thead>
                        <tr>
                            <th>Key</th>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Description</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.dashboards.map((dashboard, index) => (
                            <React.Fragment key={dashboard.key}>
                                <tr className={index % 2 === 0 ? 'table-secondary' : ''}>
                                    <td>{dashboard.key}</td>
                                    <td>{dashboard.name}</td>
                                    <td>{this.mapDashboardType(dashboard.type)}</td>
                                    <td>{dashboard.description}</td>
                                    <td>
                                        <div className="btn-group" role="group">
                                            <button
                                                className="btn btn-sm btn-primary"
                                                onClick={e => this.handleEdit(e, dashboard)}
                                            >
                                                Edit
                                            </button>
                                            <button
                                                className="btn btn-sm btn-error"
                                                onClick={e => this.handleDelete(e, dashboard)}
                                            >
                                                Delete
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                <tr className={index % 2 === 0 ? 'table-secondary dashboardUsers' : 'dashboardUsers'}>
                                    <td colSpan={5}>
                                        <div className="ps-5">
                                            <LinkedUsersManagement
                                                currentCompany={this.state.currentCompany}
                                                dashboard={dashboard}
                                                onLinkUser={this.handleLinkUser}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
                <div className="support-footer" style={{ width: "100%" }}>
                    <SupportTeam></SupportTeam>
                </div>

                {/* delete confirmation dialog */}
                {this.state.showDeleteConfirm && (
                    <Dialog title="Please confirm" onClose={this.handleCancelDelete}>
                        <p style={{ margin: '25px', textAlign: 'center' }}>
                            Do you really want to delete the dashboard <strong>{this.state.dashboardToDelete?.name}</strong>?
                        </p>
                        <DialogActionsBar>
                            <button
                                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base cancel-button"
                                onClick={this.handleCancelDelete}
                            >
                                No
                            </button>
                            <button
                                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base confirm-button"
                                

                                onClick={this.handleConfirmDelete}
                            >
                                Yes
                            </button>
                        </DialogActionsBar>
                    </Dialog>
                )}
            </Container>
        );
    }
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        console: state.console,
        router: state.router
    };
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        push: (path: string) => dispatch(push(path)),
        consoleActions: bindActionCreators(ConsoleStore.actionCreators, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardManagement);
